import { Views } from '@neos/app'
import { OpenModeType, PopupPosition } from '@neos/shared'

export const views: Views = {
  default: [
    {
      name: 'DeclEvtDUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/DeclEvtDUI/DeclEvtDUI.vue'),
    },
    {
      name: 'DeclEvtIEUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/DeclEvtIEUI/DeclEvtIEUI.vue'),
    },
    {
      name: 'DeclEvtUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/DeclEvtUI/DeclEvtUI.vue'),
    },
    {
      name: 'DeclarationsIEUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/DeclarationsIEUI/DeclarationsIEUI.vue'),
    },
    {
      name: 'EtatDouListUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/EtatDouListUI/EtatDouListUI.vue'),
    },
    {
      name: 'EventTypeDUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/EventTypeDUI/EventTypeDUI.vue'),
    },
    {
      name: 'HomePageUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/HomePageUI/HomePageUI.vue'),
    },
    {
      name: 'TypeEvtDListUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/TypeEvtDListUI/TypeEvtDListUI.vue'),
    },
    {
      name: 'TypeEvtIEUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/TypeEvtIEUI/TypeEvtIEUI.vue'),
    },
    {
      name: 'TypeEvtListUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/TypeEvtListUI/TypeEvtListUI.vue'),
    },
    {
      name: 'UserSettingsUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/UserSettingsUI/UserSettingsUI.vue'),
    },
    {
      name: 'VwDeclCumLiqCatCUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/VwDeclCumLiqCatCUI/VwDeclCumLiqCatCUI.vue'),
    },
    {
      name: 'VwDeclCumLiqCatDUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/VwDeclCumLiqCatDUI/VwDeclCumLiqCatDUI.vue'),
    },
    {
      name: 'VwDeclCumLiqCatIEUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/VwDeclCumLiqCatIEUI/VwDeclCumLiqCatIEUI.vue'),
    },
    {
      name: 'VwDeclCumLiqTotCUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/VwDeclCumLiqTotCUI/VwDeclCumLiqTotCUI.vue'),
    },
    {
      name: 'VwDeclCumLiqTotDUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/VwDeclCumLiqTotDUI/VwDeclCumLiqTotDUI.vue'),
    },
    {
      name: 'VwDeclCumLiqTotIEUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/VwDeclCumLiqTotIEUI/VwDeclCumLiqTotIEUI.vue'),
    },
    {
      name: 'VwDeclarationsCNoDetailsUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/VwDeclarationsCNoDetailsUI/VwDeclarationsCNoDetailsUI.vue'),
    },
    {
      name: 'VwDeclarationsCUI',
      openMode: OpenModeType.popupFullSize,
      popupPosition: PopupPosition.center,
      component: () => import('./views/VwDeclarationsCUI/VwDeclarationsCUI.vue'),
    },
    {
      name: 'VwDeclarationsCWithDetailsUI',
      openMode: OpenModeType.popupAutoSize,
      popupPosition: PopupPosition.center,
      component: () => import('./views/VwDeclarationsCWithDetailsUI/VwDeclarationsCWithDetailsUI.vue'),
    },
    {
      name: 'VwDeclarationsDNoDetailsUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/VwDeclarationsDNoDetailsUI/VwDeclarationsDNoDetailsUI.vue'),
    },
    {
      name: 'VwDeclarationsDUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/VwDeclarationsDUI/VwDeclarationsDUI.vue'),
    },
    {
      name: 'VwDeclarationsDWithDetailsUI',
      openMode: OpenModeType.popupAutoSize,
      popupPosition: PopupPosition.center,
      component: () => import('./views/VwDeclarationsDWithDetailsUI/VwDeclarationsDWithDetailsUI.vue'),
    },
    {
      name: 'VwDeclarationsIENoDetailsUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/VwDeclarationsIENoDetailsUI/VwDeclarationsIENoDetailsUI.vue'),
    },
    {
      name: 'VwDeclarationsIEUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/VwDeclarationsIEUI/VwDeclarationsIEUI.vue'),
    },
    {
      name: 'VwDeclarationsIEWithDetailsUI',
      openMode: OpenModeType.popupAutoSize,
      popupPosition: PopupPosition.center,
      component: () => import('./views/VwDeclarationsIEWithDetailsUI/VwDeclarationsIEWithDetailsUI.vue'),
    },
  ],
}
